"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INITIAL_BG_SIZE = exports.BG_SIZE_KEYWORDS = exports.INITIAL_BG_POSITION = exports.BG_POSITION_ALL_EDGES_KEYWORDS = exports.BG_POSITION_HORIZONTAL_KEYWORDS_MAP = exports.BG_POSITION_HORIZONTAL_KEYWORDS = exports.BG_POSITION_VERTICAL_KEYWORDS_MAP = exports.BG_POSITION_VERTICAL_KEYWORDS = exports.BG_POSITION_CENTER_KEYWORD = exports.INITIAL_IMAGE_SOURCE = exports.IMAGE_SOURCE_NONE_KEYWORD = exports.IMAGE_FUNCTIONS = exports.GRADIENT_FUNCTIONS = exports.INITIAL_BORDER_IMAGE_WIDTH = exports.INITIAL_BORDER_IMAGE_REPEAT = exports.BORDER_IMAGE_REPEAT_MULTIPLE_KEYWORDS = exports.INITIAL_BORDER_IMAGE_OUTSET = exports.INITIAL_BORDER_IMAGE_SLICE = exports.BORDER_IMAGE_SLICE_FILL_KEYWORD = exports.INITIAL_BACKGROUND_COLOR = exports.OUTLINE_COLOR_INVERT_KEYWORD = exports.INITIAL_COLOR = exports.COLOR_KEYWORDS = exports.COLOR_SPACE_FUNCTIONS = exports.INITIAL_LINE_WIDTH = exports.LINE_WIDTH_KEYWORDS = exports.INITIAL_LINE_STYLE = exports.LINE_STYLE_KEYWORDS = exports.FLEX_NUMBER_RANGE_MIN = exports.FLEX_UNIT = exports.ANGLE_UNITS = exports.LENGTH_PERCENTAGE_UNITS = exports.PERCENTAGE_UNIT = exports.SPX_FORMATTER = exports.CALC_FUNCTION = exports.LENGTH_UNITS_MAP = exports.LENGTH_UNITS = exports.SCALED_LENGTH_UNITS = exports.DEFAULT_DIMENSION = exports.getInitialValue = exports.UNIVERSAL_KEYWORDS = exports.INITIAL_UNIVERSAL = exports.NORMAL_KEYWORD = exports.NONE_KEYWORD = exports.AUTO_KEYWORD = exports.INTERNAL_VALUE_SEPERATOR = exports.DEFAULT_LAYER_SEPERATOR = exports.DATA_TYPES_MAP = exports.keywordsMap = exports.DataTypeType = void 0;
exports.INITIAL_FLEX_WRAP = exports.FLEX_WRAP_KEYWORDS = exports.INITIAL_FLEX_DIRECTION = exports.FLEX_DIRECTION_KEYWORDS = exports.INITIAL_FLEX_BASIS = exports.AUTO_FLEX_BASIS = exports.FLEX_BASIS_KEYWORDS = exports.NONE_FLEX_SHRINK = exports.INITIAL_FLEX_SHRINK = exports.AUTO_FLEX_GROW = exports.INITIAL_FLEX_GROW = exports.FLEX_SINGLE_VALUE_KEYWORDS = exports.INITIAL_JUSTIFY_ITEMS = exports.JUSTIFY_ITEMS_KEYWORDS = exports.INITIAL_ALIGN_ITEMS = exports.ALIGN_ITEMS_KEYWORDS = exports.INITIAL_JUSTIFY_CONTENT = exports.JUSTIFY_CONTENT_KEYWORDS = exports.SELF_POSITION_KEYWORDS = exports.INITIAL_ALIGN_CONTENT = exports.ALIGN_CONTENT_KEYWORDS = exports.CONTENT_POSITION_KEYWORDS = exports.CONTENT_DISTRIBUTION_KEYWORDS = exports.INITIAL_FONT_FAMILY = exports.FONT_FAMILY_GENERIC_KEYWORDS = exports.INITIAL_LINE_HEIGHT = exports.LINE_HEIGHT_KEYWORD = exports.INITIAL_FONT_SIZE = exports.FONT_SIZE_KEYWORDS = exports.INITIAL_FONT_STRETCH = exports.FONT_STRETCH_KEYWORDS = exports.INITIAL_FONT_WEIGHT = exports.FONT_WEIGHT_NUMBER_RANGE_MAX = exports.FONT_WEIGHT_NUMBER_RANGE_MIN = exports.FONT_WEIGHT_KEYWORDS = exports.INITIAL_FONT_VARIANT = exports.FONT_VARIANT_KEYWORDS = exports.INITIAL_FONT_STYLE = exports.FONT_STYLE_OBLIQUE_KEYWORD = exports.FONT_STYLE_KEYWORDS = exports.COMMON_FONT_PREFIX_NORMAL = exports.FONT_SINGLE_VALUE_KEYWORDS = exports.INITIAL_BACKGROUND_CLIP = exports.INITIAL_BACKGROUND_ORIGIN = exports.BOX_KEYWORDS = exports.INITIAL_ATTACHMENT = exports.ATTACHMENT_KEYWORDS = exports.INITIAL_REPEAT_STYLE = exports.REPEAT_STYLE_MULTIPLE_KEYWORDS = exports.REPEAT_STYLE_SINGLE_KEYWORDS = void 0;
exports.SHADOW_SINGLE_VALUE_KEYWORDS = exports.INSET_KEYWORD = exports.INITIAL_LIST_STYLE_TYPE = exports.LIST_STYLE_TYPE_KEYWORDS = exports.INITIAL_LIST_STYLE_POSITION = exports.LIST_STYLE_POSITION_KEYWORDS = exports.LIST_STYLE_SINGLE_VALUE_KEYWORD = exports.INITIAL_TEXT_DECORATION_STYLE = exports.TEXT_DECORATION_STYLE_KEYWORDS = exports.INITIAL_TEXT_DECORATION_LINE = exports.TEXT_DECORATION_LINE_KEYWORDS = exports.TEXT_DECORATION_LINE_NONE_KEYWORD = exports.INITIAL_OVERFLOW = exports.OVERFLOW_KEYWORDS = exports.GRID_SINGLE_VALUE_KEYWORD = exports.INITIAL_GRID_AUTO_AXIS = exports.INITIAL_GRID_AUTO_FLOW = exports.GRID_AUTO_FLOW_DENSE_KEYWORD = exports.GRID_AUTO_FLOW_COLUMN_KEYWORD = exports.GRID_AUTO_FLOW_ROW_KEYWORD = exports.GRID_AUTO_FLOW_KEYWORD = exports.GRID_TEMPLATE_SINGLE_VALUE_KEYWORD = exports.INITIAL_GRID_TEMPLATE_AXIS = exports.GRID_TEMPLATE_AXIS_NONE_KEYWORD = exports.INITIAL_GRID_TEMPLATE_AREAS = exports.GRID_TEMPLATE_AREAS_NONE_KEYWORD = exports.AUTO_REPEAT_FIRST_ARGUMENT_KEYWORDS = exports.INITIAL_TRACK_SIZE = exports.TRACK_SIZE_FUNCTIONS = exports.REPEAT_FUNCTION = exports.MINMAX_FUNCTION = exports.LINE_NAMES_EXCLUDE_KEYWORDS = exports.BREADTH_KEYWORDS = exports.INITIAL_GRID_LINE = exports.GRID_LINE_AUTO_KEYWORD = exports.GRID_LINE_SPAN_KEYWORD = void 0;
var tslib_1 = require("tslib");
var DataTypeType;
(function (DataTypeType) {
    DataTypeType["Unknown"] = "UNKNOWN";
    DataTypeType["Common"] = "COMMON";
    DataTypeType["Universal"] = "<universal>";
    DataTypeType["Number"] = "<number>";
    DataTypeType["Length"] = "<length>";
    DataTypeType["Percentage"] = "<percentage>";
    DataTypeType["LengthPercentage"] = "<length-percentage>";
    DataTypeType["Angle"] = "<angle>";
    DataTypeType["Width"] = "<width>";
    DataTypeType["CustomIdent"] = "<custom-ident>";
    DataTypeType["LineStyle"] = "<line-style>";
    DataTypeType["OutlineStyle"] = "<'outline-style'>";
    DataTypeType["LineWidth"] = "<line-width>";
    DataTypeType["Color"] = "<color>";
    DataTypeType["OutlineColor"] = "<'outline-color'>";
    DataTypeType["BorderImageSlice"] = "<'border-image-slice'>";
    DataTypeType["BorderImageOutset"] = "<'border-image-outset'>";
    DataTypeType["BorderImageRepeat"] = "<'border-image-repeat'>";
    DataTypeType["BorderImageWidth"] = "<'border-image-width'>";
    DataTypeType["Gradient"] = "<gradient>";
    DataTypeType["Image"] = "<image>";
    DataTypeType["ImageSource"] = "<image-source>";
    DataTypeType["BgPosition"] = "<bg-position>";
    DataTypeType["BgSize"] = "<bg-size>";
    DataTypeType["RepeatStyle"] = "<repeat-style>";
    DataTypeType["Attachment"] = "<attachment>";
    DataTypeType["Box"] = "<box>";
    DataTypeType["FontStyle"] = "<font-style>";
    DataTypeType["FontVariant"] = "<font-variant>";
    DataTypeType["FontWeight"] = "<font-weight>";
    DataTypeType["FontStretch"] = "<font-stretch>";
    DataTypeType["FontSize"] = "<font-size>";
    DataTypeType["LineHeight"] = "<line-height>";
    DataTypeType["FontFamily"] = "<font-family>";
    DataTypeType["Font"] = "<font>";
    DataTypeType["AlignContent"] = "<'align-content'>";
    DataTypeType["JustifyContent"] = "<'justify-content'>";
    DataTypeType["AlignItems"] = "<'align-items'>";
    DataTypeType["JustifyItems"] = "<'justify-items'>";
    DataTypeType["FlexGrow"] = "<flex-grow>";
    DataTypeType["FlexShrink"] = "<flex-shrink>";
    DataTypeType["FlexBasis"] = "<flex-basis>";
    DataTypeType["FlexDirection"] = "<flex-direction>";
    DataTypeType["FlexWrap"] = "<flex-wrap>";
    DataTypeType["Flex"] = "<'flex'>";
    DataTypeType["GridLine"] = "<grid-line>";
    DataTypeType["GridLineEnd"] = "<grid-line-end>";
    DataTypeType["LineNames"] = "<line-names>";
    DataTypeType["TrackList"] = "<track-list>";
    DataTypeType["AutoTrackList"] = "<auto-track-list>";
    DataTypeType["ExplicitTrackList"] = "<explicit-track-list>";
    DataTypeType["TrackListWithStrings"] = "<track-list-with-strings>";
    DataTypeType["GridTemplateAreas"] = "<grid-template-areas>";
    DataTypeType["GridTemplateRows"] = "<grid-template-rows>";
    DataTypeType["GridTemplateColumns"] = "<grid-template-columns>";
    DataTypeType["GridTemplate"] = "<grid-template>";
    DataTypeType["GridAutoFlow"] = "<grid-auto-flow>";
    DataTypeType["GridAutoRows"] = "<grid-auto-rows>";
    DataTypeType["GridAutoColumns"] = "<grid-auto-columns>";
    DataTypeType["Grid"] = "<grid>";
    DataTypeType["Overflow"] = "<overflow>";
    DataTypeType["TextDecorationLine"] = "<'text-decoration-line'>";
    DataTypeType["TextDecorationStyle"] = "<'text-decoration-style'>";
    DataTypeType["ListStyle"] = "<'list-style'>";
    DataTypeType["ListStylePosition"] = "<'list-style-position'>";
    DataTypeType["ListStyleType"] = "<'list-style-type'>";
    DataTypeType["Inset"] = "<'inset'>";
    DataTypeType["Shadow"] = "<shadow>";
})(DataTypeType = exports.DataTypeType || (exports.DataTypeType = {}));
var keywordsMap = function (keywords) { return new Map(keywords.map(function (keyword) { return [keyword, true]; })); };
exports.keywordsMap = keywordsMap;
exports.DATA_TYPES_MAP = new Map();
exports.DEFAULT_LAYER_SEPERATOR = ',';
exports.INTERNAL_VALUE_SEPERATOR = '/';
exports.AUTO_KEYWORD = 'auto';
exports.NONE_KEYWORD = 'none';
exports.NORMAL_KEYWORD = 'normal';
// <universal>
exports.INITIAL_UNIVERSAL = 'initial';
exports.UNIVERSAL_KEYWORDS = (0, exports.keywordsMap)(['inherit', exports.INITIAL_UNIVERSAL, 'unset', 'revert']);
exports.DATA_TYPES_MAP.set(DataTypeType.Universal, {
    initial: exports.INITIAL_UNIVERSAL,
    keywords: exports.UNIVERSAL_KEYWORDS,
});
var getInitialValue = function (dataType) { var _a, _b; return (_b = (_a = exports.DATA_TYPES_MAP.get(dataType)) === null || _a === void 0 ? void 0 : _a.initial) !== null && _b !== void 0 ? _b : exports.INITIAL_UNIVERSAL; };
exports.getInitialValue = getInitialValue;
// <length> / <length-percentage> / <width> / <margin> / <padding> / <border-radius>
exports.DEFAULT_DIMENSION = '0';
exports.DATA_TYPES_MAP.set(DataTypeType.Length, { initial: exports.DEFAULT_DIMENSION });
exports.DATA_TYPES_MAP.set(DataTypeType.LengthPercentage, { initial: exports.DEFAULT_DIMENSION });
exports.DATA_TYPES_MAP.set(DataTypeType.Width, { initial: exports.DEFAULT_DIMENSION });
// <length>
var ABSOLUTE_LENGTH_UNITS = ['px', 'cm', 'mm', 'Q', 'in', 'pc', 'pt'];
var RELATIVE_LENGTH_UNITS = [
    'em',
    'rem',
    'vw',
    'vh',
    'vi',
    'vb',
    'vmin',
    'vmax',
    'ex',
    'cap',
    'ch',
    'ic',
    'lh',
    'rlh',
    'cqw',
    'cqh',
    'cqi',
    'cqb',
    'cqmin',
    'cqmax',
];
exports.SCALED_LENGTH_UNITS = ['spx'];
exports.LENGTH_UNITS = tslib_1.__spreadArray(tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(ABSOLUTE_LENGTH_UNITS), false), tslib_1.__read(RELATIVE_LENGTH_UNITS), false), tslib_1.__read(exports.SCALED_LENGTH_UNITS), false);
exports.LENGTH_UNITS_MAP = (0, exports.keywordsMap)(exports.LENGTH_UNITS);
exports.CALC_FUNCTION = 'calc';
exports.SPX_FORMATTER = 'spx';
// <percentage>
exports.PERCENTAGE_UNIT = '%';
exports.LENGTH_PERCENTAGE_UNITS = (0, exports.keywordsMap)(exports.LENGTH_UNITS.concat(exports.PERCENTAGE_UNIT));
// <angle>
exports.ANGLE_UNITS = (0, exports.keywordsMap)(['deg', 'grad', 'rad', 'turn']);
// <flex>
exports.FLEX_UNIT = 'fr';
exports.FLEX_NUMBER_RANGE_MIN = 0;
// <line-style>
exports.LINE_STYLE_KEYWORDS = (0, exports.keywordsMap)([
    exports.NONE_KEYWORD,
    'hidden',
    'dotted',
    'dashed',
    'solid',
    'double',
    'groove',
    'ridge',
    'inset',
    'outset',
]);
exports.INITIAL_LINE_STYLE = exports.NONE_KEYWORD;
exports.DATA_TYPES_MAP.set(DataTypeType.LineStyle, {
    initial: exports.INITIAL_LINE_STYLE,
    keywords: exports.LINE_STYLE_KEYWORDS,
});
exports.DATA_TYPES_MAP.set(DataTypeType.OutlineStyle, { initial: exports.INITIAL_LINE_STYLE });
// <line-width>
exports.LINE_WIDTH_KEYWORDS = (0, exports.keywordsMap)(['thin', 'medium', 'thick']);
exports.INITIAL_LINE_WIDTH = 'medium';
exports.DATA_TYPES_MAP.set(DataTypeType.LineWidth, { initial: exports.INITIAL_LINE_WIDTH });
// <color>
exports.COLOR_SPACE_FUNCTIONS = (0, exports.keywordsMap)(['rgb', 'rgba', 'hsl', 'hsla', 'hexAlpha']);
// <named-color>
var NAMED_COLOR_KEYWORDS = [
    'transparent',
    'aliceblue',
    'antiquewhite',
    'aqua',
    'aquamarine',
    'azure',
    'beige',
    'bisque',
    'black',
    'blanchedalmond',
    'blue',
    'blueviolet',
    'brown',
    'burlywood',
    'cadetblue',
    'chartreuse',
    'chocolate',
    'coral',
    'cornflowerblue',
    'cornsilk',
    'crimson',
    'cyan',
    'darkblue',
    'darkcyan',
    'darkgoldenrod',
    'darkgray',
    'darkgreen',
    'darkgrey',
    'darkkhaki',
    'darkmagenta',
    'darkolivegreen',
    'darkorange',
    'darkorchid',
    'darkred',
    'darksalmon',
    'darkseagreen',
    'darkslateblue',
    'darkslategray',
    'darkslategrey',
    'darkturquoise',
    'darkviolet',
    'deeppink',
    'deepskyblue',
    'dimgray',
    'dimgrey',
    'dodgerblue',
    'firebrick',
    'floralwhite',
    'forestgreen',
    'fuchsia',
    'gainsboro',
    'ghostwhite',
    'gold',
    'goldenrod',
    'gray',
    'green',
    'greenyellow',
    'grey',
    'honeydew',
    'hotpink',
    'indianred',
    'indigo',
    'ivory',
    'khaki',
    'lavender',
    'lavenderblush',
    'lawngreen',
    'lemonchiffon',
    'lightblue',
    'lightcoral',
    'lightcyan',
    'lightgoldenrodyellow',
    'lightgray',
    'lightgreen',
    'lightgrey',
    'lightpink',
    'lightsalmon',
    'lightseagreen',
    'lightskyblue',
    'lightslategray',
    'lightslategrey',
    'lightsteelblue',
    'lightyellow',
    'lime',
    'limegreen',
    'linen',
    'magenta',
    'maroon',
    'mediumaquamarine',
    'mediumblue',
    'mediumorchid',
    'mediumpurple',
    'mediumseagreen',
    'mediumslateblue',
    'mediumspringgreen',
    'mediumturquoise',
    'mediumvioletred',
    'midnightblue',
    'mintcream',
    'mistyrose',
    'moccasin',
    'navajowhite',
    'navy',
    'oldlace',
    'olive',
    'olivedrab',
    'orange',
    'orangered',
    'orchid',
    'palegoldenrod',
    'palegreen',
    'paleturquoise',
    'palevioletred',
    'papayawhip',
    'peachpuff',
    'peru',
    'pink',
    'plum',
    'powderblue',
    'purple',
    'rebeccapurple',
    'red',
    'rosybrown',
    'royalblue',
    'saddlebrown',
    'salmon',
    'sandybrown',
    'seagreen',
    'seashell',
    'sienna',
    'silver',
    'skyblue',
    'slateblue',
    'slategray',
    'slategrey',
    'snow',
    'springgreen',
    'steelblue',
    'tan',
    'teal',
    'thistle',
    'tomato',
    'turquoise',
    'violet',
    'wheat',
    'white',
    'whitesmoke',
    'yellow',
    'yellowgreen',
];
var CURRENT_COLOR_KEYWORD = 'currentcolor';
// <deprecated-system-color>
var DEPRECATED_SYSTEM_COLOR_KEYWORD = [
    'ActiveBorder',
    'ActiveCaption',
    'AppWorkspace',
    'Background',
    'ButtonFace',
    'ButtonHighlight',
    'ButtonShadow',
    'ButtonText',
    'CaptionText',
    'GrayText',
    'Highlight',
    'HighlightText',
    'InactiveBorder',
    'InactiveCaption',
    'InactiveCaptionText',
    'InfoBackground',
    'InfoText',
    'Menu',
    'MenuText',
    'Scrollbar',
    'ThreeDDarkShadow',
    'ThreeDFace',
    'ThreeDHighlight',
    'ThreeDLightShadow',
    'ThreeDShadow',
    'Window',
    'WindowFrame',
    'WindowText',
];
exports.COLOR_KEYWORDS = (0, exports.keywordsMap)(NAMED_COLOR_KEYWORDS.concat(CURRENT_COLOR_KEYWORD).concat(DEPRECATED_SYSTEM_COLOR_KEYWORD));
exports.INITIAL_COLOR = CURRENT_COLOR_KEYWORD;
exports.DATA_TYPES_MAP.set(DataTypeType.Color, { initial: exports.INITIAL_COLOR });
// <'outline-color'>
exports.OUTLINE_COLOR_INVERT_KEYWORD = 'invert';
exports.DATA_TYPES_MAP.set(DataTypeType.OutlineColor, { initial: exports.INITIAL_COLOR });
// <background-color>
exports.INITIAL_BACKGROUND_COLOR = 'transparent';
// <border-image-slice>
exports.BORDER_IMAGE_SLICE_FILL_KEYWORD = 'fill';
exports.INITIAL_BORDER_IMAGE_SLICE = '100%';
exports.DATA_TYPES_MAP.set(DataTypeType.BorderImageSlice, { initial: exports.INITIAL_BORDER_IMAGE_SLICE });
// <border-image-outset>
exports.INITIAL_BORDER_IMAGE_OUTSET = exports.DEFAULT_DIMENSION;
exports.DATA_TYPES_MAP.set(DataTypeType.BorderImageOutset, {
    initial: exports.INITIAL_BORDER_IMAGE_OUTSET,
    prefix: DataTypeType.BorderImageWidth,
});
// <border-image-repeat>
exports.BORDER_IMAGE_REPEAT_MULTIPLE_KEYWORDS = (0, exports.keywordsMap)(['stretch', 'repeat', 'round', 'space']);
exports.INITIAL_BORDER_IMAGE_REPEAT = 'stretch';
exports.DATA_TYPES_MAP.set(DataTypeType.BorderImageRepeat, { initial: exports.INITIAL_BORDER_IMAGE_REPEAT });
// <border-image-width>
exports.INITIAL_BORDER_IMAGE_WIDTH = '1';
exports.DATA_TYPES_MAP.set(DataTypeType.BorderImageWidth, {
    initial: exports.INITIAL_BORDER_IMAGE_WIDTH,
    prefix: DataTypeType.BorderImageSlice,
});
// <gradient>
exports.GRADIENT_FUNCTIONS = (0, exports.keywordsMap)([
    'linear-gradient',
    'repeating-linear-gradient',
    'radial-gradient',
    'repeating-radial-gradient',
    'conic-gradient',
]);
// <image>
exports.IMAGE_FUNCTIONS = (0, exports.keywordsMap)(['url', 'image', 'image-set', 'element', 'paint', 'cross-fade']);
// <image-source>
exports.IMAGE_SOURCE_NONE_KEYWORD = exports.NONE_KEYWORD;
exports.INITIAL_IMAGE_SOURCE = exports.IMAGE_SOURCE_NONE_KEYWORD;
exports.DATA_TYPES_MAP.set(DataTypeType.ImageSource, { initial: exports.INITIAL_IMAGE_SOURCE });
// <bg-position>
exports.BG_POSITION_CENTER_KEYWORD = 'center';
exports.BG_POSITION_VERTICAL_KEYWORDS = ['top', 'bottom'];
exports.BG_POSITION_VERTICAL_KEYWORDS_MAP = (0, exports.keywordsMap)(exports.BG_POSITION_VERTICAL_KEYWORDS);
exports.BG_POSITION_HORIZONTAL_KEYWORDS = ['left', 'right'];
exports.BG_POSITION_HORIZONTAL_KEYWORDS_MAP = (0, exports.keywordsMap)(exports.BG_POSITION_HORIZONTAL_KEYWORDS);
exports.BG_POSITION_ALL_EDGES_KEYWORDS = (0, exports.keywordsMap)(exports.BG_POSITION_HORIZONTAL_KEYWORDS.concat(exports.BG_POSITION_VERTICAL_KEYWORDS));
exports.INITIAL_BG_POSITION = '0% 0%';
exports.DATA_TYPES_MAP.set(DataTypeType.BgPosition, { initial: exports.INITIAL_BG_POSITION });
// <bg-size>
exports.BG_SIZE_KEYWORDS = (0, exports.keywordsMap)(['cover', 'contain']);
exports.INITIAL_BG_SIZE = exports.AUTO_KEYWORD;
exports.DATA_TYPES_MAP.set(DataTypeType.BgSize, {
    initial: exports.INITIAL_BG_SIZE,
    prefix: DataTypeType.BgPosition,
});
// <repeat-style>
exports.REPEAT_STYLE_SINGLE_KEYWORDS = (0, exports.keywordsMap)(['repeat-x', 'repeat-y']);
exports.REPEAT_STYLE_MULTIPLE_KEYWORDS = (0, exports.keywordsMap)(['repeat', 'space', 'round', 'no-repeat']);
exports.INITIAL_REPEAT_STYLE = 'repeat';
exports.DATA_TYPES_MAP.set(DataTypeType.RepeatStyle, { initial: exports.INITIAL_REPEAT_STYLE });
// <attachment>
exports.ATTACHMENT_KEYWORDS = (0, exports.keywordsMap)(['scroll', 'fixed', 'local']);
exports.INITIAL_ATTACHMENT = 'scroll';
exports.DATA_TYPES_MAP.set(DataTypeType.Attachment, {
    initial: exports.INITIAL_ATTACHMENT,
    keywords: exports.ATTACHMENT_KEYWORDS,
});
// <box>
exports.BOX_KEYWORDS = (0, exports.keywordsMap)(['border-box', 'padding-box', 'content-box']);
exports.INITIAL_BACKGROUND_ORIGIN = 'padding-box';
exports.INITIAL_BACKGROUND_CLIP = 'border-box';
exports.DATA_TYPES_MAP.set(DataTypeType.Box, { keywords: exports.BOX_KEYWORDS });
// <font>
exports.FONT_SINGLE_VALUE_KEYWORDS = (0, exports.keywordsMap)([
    'caption',
    'icon',
    'menu',
    'message-box',
    'small-caption',
    'status-bar',
]);
exports.DATA_TYPES_MAP.set(DataTypeType.Font, { keywords: exports.FONT_SINGLE_VALUE_KEYWORDS });
exports.COMMON_FONT_PREFIX_NORMAL = exports.NORMAL_KEYWORD;
// <font-style>
exports.FONT_STYLE_KEYWORDS = (0, exports.keywordsMap)([exports.COMMON_FONT_PREFIX_NORMAL, 'italic']);
exports.FONT_STYLE_OBLIQUE_KEYWORD = 'oblique';
exports.INITIAL_FONT_STYLE = exports.COMMON_FONT_PREFIX_NORMAL;
exports.DATA_TYPES_MAP.set(DataTypeType.FontStyle, { initial: exports.INITIAL_FONT_STYLE });
// <font-variant>
var FONT_VARIANT_LIGATURES_KEYWORDS = [
    'common-ligatures',
    'no-common-ligatures',
    'discretionary-ligatures',
    'no-discretionary-ligatures',
    'historical-ligatures',
    'no-historical-ligatures',
    'contextual',
    'no-contextual',
];
var FONT_VARIANT_CAPS_KEYWORDS = [
    'small-caps',
    'all-small-caps',
    'petite-caps',
    'all-petite-caps',
    'unicase',
    'titling-caps',
];
var FONT_VARIANT_NUMERIC_KEYWORDS = [
    'lining-nums',
    'oldstyle-nums',
    'proportional-nums',
    'tabular-nums',
    'diagonal-fractions',
    'stacked-fractions',
    'ordinal',
    'slashed-zero',
];
var FONT_VARIANT_EAST_ASIAN_KEYWORDS = [
    'jis78',
    'jis83',
    'jis90',
    'jis04',
    'simplified',
    'traditional',
    'full-width',
    'proportional-width',
    'ruby',
];
exports.FONT_VARIANT_KEYWORDS = (0, exports.keywordsMap)([exports.COMMON_FONT_PREFIX_NORMAL, exports.NONE_KEYWORD]
    .concat(FONT_VARIANT_LIGATURES_KEYWORDS)
    .concat(FONT_VARIANT_CAPS_KEYWORDS)
    .concat(FONT_VARIANT_NUMERIC_KEYWORDS)
    .concat(FONT_VARIANT_EAST_ASIAN_KEYWORDS));
exports.INITIAL_FONT_VARIANT = exports.COMMON_FONT_PREFIX_NORMAL;
exports.DATA_TYPES_MAP.set(DataTypeType.FontVariant, {
    initial: exports.INITIAL_FONT_VARIANT,
    keywords: exports.FONT_VARIANT_KEYWORDS,
});
// <font-weight>
var FONT_WEIGHT_ABSOLUTE_KEYWORDS = [exports.COMMON_FONT_PREFIX_NORMAL, 'bold'];
var FONT_WEIGHT_RELATIVE_KEYWORDS = ['lighter', 'bolder'];
exports.FONT_WEIGHT_KEYWORDS = (0, exports.keywordsMap)(FONT_WEIGHT_ABSOLUTE_KEYWORDS.concat(FONT_WEIGHT_RELATIVE_KEYWORDS));
exports.FONT_WEIGHT_NUMBER_RANGE_MIN = 1;
exports.FONT_WEIGHT_NUMBER_RANGE_MAX = 1000;
exports.INITIAL_FONT_WEIGHT = exports.COMMON_FONT_PREFIX_NORMAL;
exports.DATA_TYPES_MAP.set(DataTypeType.FontWeight, { initial: exports.INITIAL_FONT_WEIGHT });
// <font-stretch>
exports.FONT_STRETCH_KEYWORDS = (0, exports.keywordsMap)([
    exports.COMMON_FONT_PREFIX_NORMAL,
    'ultra-condensed',
    'extra-condensed',
    'condensed',
    'semi-condensed',
    'semi-expanded',
    'expanded',
    'extra-expanded',
    'ultra-expanded',
]);
exports.INITIAL_FONT_STRETCH = exports.COMMON_FONT_PREFIX_NORMAL;
exports.DATA_TYPES_MAP.set(DataTypeType.FontStretch, {
    initial: exports.INITIAL_FONT_STRETCH,
    keywords: exports.FONT_STRETCH_KEYWORDS,
});
// <font-size>
var FONT_SIZE_ABSOLUTE_KEYWORDS = [
    'xx-small',
    'x-small',
    'small',
    'medium',
    'large',
    'x-large',
    'xx-large',
    'xxx-large',
];
var FONT_SIZE_RELATIVE_KEYWORDS = ['larger', 'smaller'];
exports.FONT_SIZE_KEYWORDS = (0, exports.keywordsMap)(FONT_SIZE_ABSOLUTE_KEYWORDS.concat(FONT_SIZE_RELATIVE_KEYWORDS));
exports.INITIAL_FONT_SIZE = 'medium';
exports.DATA_TYPES_MAP.set(DataTypeType.FontSize, { initial: exports.INITIAL_FONT_SIZE });
// <line-height>
exports.LINE_HEIGHT_KEYWORD = exports.NORMAL_KEYWORD;
exports.INITIAL_LINE_HEIGHT = exports.LINE_HEIGHT_KEYWORD;
exports.DATA_TYPES_MAP.set(DataTypeType.LineHeight, {
    initial: exports.INITIAL_LINE_HEIGHT,
    prefix: DataTypeType.FontSize,
});
// <font-family>
exports.FONT_FAMILY_GENERIC_KEYWORDS = (0, exports.keywordsMap)([
    'serif',
    'sans-serif',
    'cursive',
    'fantasy',
    'monospace',
    'system-ui',
    'ui-serif',
    'ui-sans-serif',
    'ui-monospace',
    'ui-rounded',
    'emoji',
    'math',
    'fangsong',
]);
exports.INITIAL_FONT_FAMILY = '';
exports.DATA_TYPES_MAP.set(DataTypeType.FontFamily, { initial: exports.INITIAL_FONT_FAMILY });
// <baseline-position>
var BASELINE_KEYWORD = 'baseline';
var STRETCH_KEYWORD = 'stretch';
// <content-distribution>
exports.CONTENT_DISTRIBUTION_KEYWORDS = (0, exports.keywordsMap)([
    'space-between',
    'space-around',
    'space-evenly',
    STRETCH_KEYWORD,
]);
// <content-position>
var CONTENT_POSITION_LIST = ['center', 'flex-start', 'flex-end'];
exports.CONTENT_POSITION_KEYWORDS = (0, exports.keywordsMap)(CONTENT_POSITION_LIST);
// <align-content>
exports.ALIGN_CONTENT_KEYWORDS = (0, exports.keywordsMap)([exports.NORMAL_KEYWORD, BASELINE_KEYWORD]);
exports.INITIAL_ALIGN_CONTENT = exports.NORMAL_KEYWORD;
exports.DATA_TYPES_MAP.set(DataTypeType.AlignContent, { initial: exports.INITIAL_ALIGN_CONTENT });
// <self-position>
exports.SELF_POSITION_KEYWORDS = (0, exports.keywordsMap)(CONTENT_POSITION_LIST.concat(['start', 'end', 'self-start', 'self-end']));
// <justify-content>
exports.JUSTIFY_CONTENT_KEYWORDS = (0, exports.keywordsMap)([exports.NORMAL_KEYWORD, 'left', 'right']);
exports.INITIAL_JUSTIFY_CONTENT = exports.NORMAL_KEYWORD;
exports.DATA_TYPES_MAP.set(DataTypeType.JustifyContent, { initial: exports.INITIAL_JUSTIFY_CONTENT });
// <align-items>
exports.ALIGN_ITEMS_KEYWORDS = (0, exports.keywordsMap)([exports.NORMAL_KEYWORD, STRETCH_KEYWORD, BASELINE_KEYWORD]);
exports.INITIAL_ALIGN_ITEMS = exports.NORMAL_KEYWORD;
exports.DATA_TYPES_MAP.set(DataTypeType.AlignItems, { initial: exports.INITIAL_ALIGN_ITEMS });
// <justify-items>
exports.JUSTIFY_ITEMS_KEYWORDS = (0, exports.keywordsMap)(['legacy', 'left', 'right', 'center']);
exports.INITIAL_JUSTIFY_ITEMS = 'legacy';
exports.DATA_TYPES_MAP.set(DataTypeType.JustifyItems, { initial: exports.INITIAL_JUSTIFY_ITEMS });
// <'flex'>
exports.FLEX_SINGLE_VALUE_KEYWORDS = (0, exports.keywordsMap)([exports.INITIAL_UNIVERSAL, exports.AUTO_KEYWORD, exports.NONE_KEYWORD]);
exports.DATA_TYPES_MAP.set(DataTypeType.Flex, { keywords: exports.FLEX_SINGLE_VALUE_KEYWORDS });
// <flex-grow>
exports.INITIAL_FLEX_GROW = exports.DEFAULT_DIMENSION;
exports.AUTO_FLEX_GROW = '1';
exports.DATA_TYPES_MAP.set(DataTypeType.FlexGrow, { initial: exports.INITIAL_FLEX_GROW });
// <flex-shrink>
exports.INITIAL_FLEX_SHRINK = '1';
exports.NONE_FLEX_SHRINK = exports.DEFAULT_DIMENSION;
exports.DATA_TYPES_MAP.set(DataTypeType.FlexShrink, { initial: exports.INITIAL_FLEX_SHRINK });
// <flex-basis>
var FLEX_BASIS_CONTENT_KEYWORD = 'content';
var FLEX_BASIS_INTRINSIC_SIZING_KEYWORDS = ['fill', 'max-content', 'min-content', 'fit-content'];
exports.FLEX_BASIS_KEYWORDS = (0, exports.keywordsMap)(FLEX_BASIS_INTRINSIC_SIZING_KEYWORDS.concat(FLEX_BASIS_CONTENT_KEYWORD));
exports.AUTO_FLEX_BASIS = exports.AUTO_KEYWORD;
exports.INITIAL_FLEX_BASIS = exports.DEFAULT_DIMENSION;
exports.DATA_TYPES_MAP.set(DataTypeType.FlexBasis, { initial: exports.INITIAL_FLEX_BASIS });
// <flex-direction>
exports.FLEX_DIRECTION_KEYWORDS = (0, exports.keywordsMap)(['row', 'row-reverse', 'column', 'column-reverse']);
exports.INITIAL_FLEX_DIRECTION = 'row';
exports.DATA_TYPES_MAP.set(DataTypeType.FlexDirection, {
    initial: exports.INITIAL_FLEX_DIRECTION,
    keywords: exports.FLEX_DIRECTION_KEYWORDS,
});
// <flex-wrap>
exports.FLEX_WRAP_KEYWORDS = (0, exports.keywordsMap)(['nowrap', 'wrap', 'wrap-reverse']);
exports.INITIAL_FLEX_WRAP = 'nowrap';
exports.DATA_TYPES_MAP.set(DataTypeType.FlexWrap, {
    initial: exports.INITIAL_FLEX_WRAP,
    keywords: exports.FLEX_WRAP_KEYWORDS,
});
// <grid-line>
exports.GRID_LINE_SPAN_KEYWORD = 'span';
exports.GRID_LINE_AUTO_KEYWORD = exports.AUTO_KEYWORD;
exports.INITIAL_GRID_LINE = exports.AUTO_KEYWORD;
exports.DATA_TYPES_MAP.set(DataTypeType.GridLine, { initial: exports.INITIAL_GRID_LINE });
exports.DATA_TYPES_MAP.set(DataTypeType.GridLineEnd, {
    initial: exports.INITIAL_GRID_LINE,
    prefix: DataTypeType.GridLine,
});
// <track-breadth> / <inflexible-breadth>
exports.BREADTH_KEYWORDS = (0, exports.keywordsMap)(['min-content', 'max-content', exports.AUTO_KEYWORD]);
// <line-names>
exports.LINE_NAMES_EXCLUDE_KEYWORDS = (0, exports.keywordsMap)(['span', exports.AUTO_KEYWORD]);
exports.MINMAX_FUNCTION = 'minmax';
exports.REPEAT_FUNCTION = 'repeat';
// <track-size>
exports.TRACK_SIZE_FUNCTIONS = (0, exports.keywordsMap)([exports.MINMAX_FUNCTION, 'fit-content']);
exports.INITIAL_TRACK_SIZE = exports.AUTO_KEYWORD;
// <explicit-track-list>
exports.DATA_TYPES_MAP.set(DataTypeType.ExplicitTrackList, { prefix: DataTypeType.GridTemplateRows });
// <auto-repeat>
exports.AUTO_REPEAT_FIRST_ARGUMENT_KEYWORDS = (0, exports.keywordsMap)(['auto-fill', 'auto-fit']);
// <grid-template-areas>
exports.GRID_TEMPLATE_AREAS_NONE_KEYWORD = exports.NONE_KEYWORD;
exports.INITIAL_GRID_TEMPLATE_AREAS = exports.GRID_TEMPLATE_AREAS_NONE_KEYWORD;
exports.DATA_TYPES_MAP.set(DataTypeType.GridTemplateAreas, { initial: exports.INITIAL_GRID_TEMPLATE_AREAS });
// <grid-template-rows> / <grid-template-columns>
exports.GRID_TEMPLATE_AXIS_NONE_KEYWORD = exports.NONE_KEYWORD;
exports.INITIAL_GRID_TEMPLATE_AXIS = exports.GRID_TEMPLATE_AXIS_NONE_KEYWORD;
exports.DATA_TYPES_MAP.set(DataTypeType.GridTemplateRows, { initial: exports.INITIAL_GRID_TEMPLATE_AXIS });
exports.DATA_TYPES_MAP.set(DataTypeType.GridTemplateColumns, {
    initial: exports.INITIAL_GRID_TEMPLATE_AXIS,
    prefix: DataTypeType.GridTemplateRows,
});
// <grid-template>
exports.GRID_TEMPLATE_SINGLE_VALUE_KEYWORD = exports.NONE_KEYWORD;
exports.DATA_TYPES_MAP.set(DataTypeType.GridTemplate, { keywords: exports.GRID_TEMPLATE_SINGLE_VALUE_KEYWORD });
// <grid-auto-flow>
exports.GRID_AUTO_FLOW_KEYWORD = 'auto-flow';
exports.GRID_AUTO_FLOW_ROW_KEYWORD = 'row';
exports.GRID_AUTO_FLOW_COLUMN_KEYWORD = 'column';
exports.GRID_AUTO_FLOW_DENSE_KEYWORD = 'dense';
exports.INITIAL_GRID_AUTO_FLOW = exports.GRID_AUTO_FLOW_ROW_KEYWORD;
exports.DATA_TYPES_MAP.set(DataTypeType.GridAutoFlow, { initial: exports.INITIAL_GRID_AUTO_FLOW });
// <grid-auto-rows> / <grid-auto-columns>
exports.INITIAL_GRID_AUTO_AXIS = exports.AUTO_KEYWORD;
exports.DATA_TYPES_MAP.set(DataTypeType.GridAutoRows, { initial: exports.INITIAL_GRID_AUTO_AXIS });
exports.DATA_TYPES_MAP.set(DataTypeType.GridAutoColumns, { initial: exports.INITIAL_GRID_AUTO_AXIS });
// <grid>
exports.GRID_SINGLE_VALUE_KEYWORD = exports.NONE_KEYWORD;
exports.DATA_TYPES_MAP.set(DataTypeType.Grid, { keywords: exports.GRID_SINGLE_VALUE_KEYWORD });
// <overflow>
exports.OVERFLOW_KEYWORDS = (0, exports.keywordsMap)(['visible', 'hidden', 'clip', 'scroll', exports.AUTO_KEYWORD]);
exports.INITIAL_OVERFLOW = 'visible';
exports.DATA_TYPES_MAP.set(DataTypeType.Overflow, {
    initial: exports.INITIAL_OVERFLOW,
    keywords: exports.OVERFLOW_KEYWORDS,
});
// <text-decoration-line>
exports.TEXT_DECORATION_LINE_NONE_KEYWORD = exports.NONE_KEYWORD;
exports.TEXT_DECORATION_LINE_KEYWORDS = (0, exports.keywordsMap)(['underline', 'overline', 'line-through']);
exports.INITIAL_TEXT_DECORATION_LINE = exports.TEXT_DECORATION_LINE_NONE_KEYWORD;
exports.DATA_TYPES_MAP.set(DataTypeType.TextDecorationLine, { initial: exports.INITIAL_TEXT_DECORATION_LINE });
// <text-decoration-style>
exports.TEXT_DECORATION_STYLE_KEYWORDS = (0, exports.keywordsMap)(['solid', 'double', 'dotted', 'dashed', 'wavy']);
exports.INITIAL_TEXT_DECORATION_STYLE = 'solid';
exports.DATA_TYPES_MAP.set(DataTypeType.TextDecorationStyle, {
    initial: exports.INITIAL_TEXT_DECORATION_STYLE,
    keywords: exports.TEXT_DECORATION_STYLE_KEYWORDS,
});
// <list-style>
exports.LIST_STYLE_SINGLE_VALUE_KEYWORD = exports.NONE_KEYWORD;
exports.DATA_TYPES_MAP.set(DataTypeType.ListStyle, { keywords: exports.LIST_STYLE_SINGLE_VALUE_KEYWORD });
// <list-style-position>
exports.LIST_STYLE_POSITION_KEYWORDS = (0, exports.keywordsMap)(['inside', 'outside']);
exports.INITIAL_LIST_STYLE_POSITION = 'outside';
exports.DATA_TYPES_MAP.set(DataTypeType.ListStylePosition, {
    initial: exports.INITIAL_LIST_STYLE_POSITION,
    keywords: exports.LIST_STYLE_POSITION_KEYWORDS,
});
// <list-style-type>
exports.LIST_STYLE_TYPE_KEYWORDS = (0, exports.keywordsMap)([
    exports.NONE_KEYWORD,
    'disc',
    'circle',
    'square',
    'decimal',
    'cjk-decimal',
    'decimal-leading-zero',
    'lower-roman',
    'upper-roman',
    'lower-greek',
    'lower-alpha',
    'lower-latin',
    'upper-alpha',
    'upper-latin',
    'arabic-indic',
    '-moz-arabic-indic',
    'armenian',
    'bengali',
    '-moz-bengali',
    'cambodian',
    'khmer',
    'cjk-earthly-branch',
    '-moz-cjk-earthly-branch',
    'cjk-heavenly-stem',
    '-moz-cjk-heavenly-stem',
    'cjk-ideographic',
    'devanagari',
    '-moz-devanagari',
    'ethiopic-numeric',
    'georgian',
    'gujarati',
    '-moz-gujarati',
    'gurmukhi',
    '-moz-gurmukhi',
    'hebrew',
    'hiragana',
    'hiragana-iroha',
    'japanese-formal',
    'japanese-informal',
    'kannada',
    '-moz-kannada',
    'katakana',
    'katakana-iroha',
    'korean-hangul-formal',
    'korean-hanja-formal',
    'korean-hanja-informal',
    'lao',
    '-moz-lao',
    'lower-armenian',
    'malayalam',
    '-moz-malayalam',
    'mongolian',
    'myanmar',
    '-moz-myanmar',
    'oriya',
    '-moz-oriya',
    'persian',
    '-moz-persian',
    'simp-chinese-formal',
    'simp-chinese-informal',
    'tamil',
    '-moz-tamil',
    'telugu',
    '-moz-telugu',
    'thai',
    '-moz-thai',
    'tibetan',
    'trad-chinese-formal',
    'trad-chinese-informal',
    'upper-armenian',
    'disclosure-open',
    'disclosure-closed',
    '-moz-ethiopic-halehame',
    '-moz-ethiopic-halehame-am',
    'ethiopic-halehame-ti-er',
    '-moz-ethiopic-halehame-ti-er',
    'ethiopic-halehame-ti-et',
    '-moz-ethiopic-halehame-ti-et',
    'hangul',
    '-moz-hangul',
    'hangul-consonant',
    '-moz-hangul-consonant',
    'urdu',
    '-moz-urdu',
]);
exports.INITIAL_LIST_STYLE_TYPE = 'disc';
exports.DATA_TYPES_MAP.set(DataTypeType.ListStyleType, { initial: exports.INITIAL_LIST_STYLE_TYPE });
// <inset>
exports.INSET_KEYWORD = 'inset';
exports.DATA_TYPES_MAP.set(DataTypeType.Inset, { keywords: exports.INSET_KEYWORD });
// <shadow>
exports.SHADOW_SINGLE_VALUE_KEYWORDS = (0, exports.keywordsMap)([exports.NONE_KEYWORD]);
exports.DATA_TYPES_MAP.set(DataTypeType.Shadow, { keywords: exports.SHADOW_SINGLE_VALUE_KEYWORDS });
//# sourceMappingURL=data-types-consts.js.map